import { ControllerPaletteColor } from '../../palette/colors/__palette-color';
import { ControllerFont } from '../../fonts';

//
// Currently, the MUI DateRangePicker is a lab component
// and does not yet have any Mui*DateRangePicker styles
// defined in the Components interface; therefore, until
// it is promoted to a first-class component, define our
// own style object for it.
//

export const ControllerDateRangePickerStyles = {
  DayOfMonthHeaderColorFg: ControllerPaletteColor.Gray400,
  DayOfMonthHeaderFont: ControllerFont.Heading250M,
};
